<template>
  <div>
    <div class="message" v-if="getBet.odds.length == 0">
      <span class="title">{{ $t('noOddsSelected') }}</span
      ><br />
      <span class="subTitle">{{ $t('pleaseSelectOdd') }}</span>
    </div>
    <div v-else>
      <BetTypeSelector></BetTypeSelector>
      <BetOddsSummary></BetOddsSummary>

      <v-progress-linear
        indeterminate
        color="primary darken-2"
        v-if="getLoading"
      ></v-progress-linear>

      <div v-if="getBet.type == 'single' || getBet.type == 'multiple'">
        <SummarySingleMultiple></SummarySingleMultiple>
      </div>
      <div v-else-if="getBet.type == 'integral'">
        <SummaryIntegral></SummaryIntegral>
      </div>
      <div v-else-if="getBet.type == 'system'">
        <SummarySystem></SummarySystem>
      </div>
    </div>
    <Errors></Errors>
    <Warnings></Warnings>
    <Actions></Actions>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import BetTypeSelector from '@/components/right_widgets/BetTypeSelector'
import BetOddsSummary from '@/components/right_widgets/BetOddsSummary'
import SummarySingleMultiple from '@/components/right_widgets/SummarySingleMultiple'
import SummaryIntegral from '@/components/right_widgets/SummaryIntegral'
import SummarySystem from '@/components/right_widgets/SummarySystem'
import Actions from '@/components/right_widgets/Actions'
import Errors from '@/components/right_widgets/Errors'
import Warnings from '@/components/right_widgets/Warnings'

export default {
  name: 'BetSlip',
  components: {
    Warnings,
    Actions,
    Errors,
    SummarySystem,
    SummaryIntegral,
    SummarySingleMultiple,
    BetOddsSummary,
    BetTypeSelector,
  },
  data: () => ({}),
  computed: {
    ...mapGetters({
      getLanguage: 'settings/getLanguage',
      getBet: 'cart/getBet',
      getSettings: 'cart/getSettings',
      getLoading: 'cart/getLoading',
    }),
  },
  methods: {
    ...mapActions({
      setLoadingCart: 'cart/setLoadingCart',
      refreshCart: 'cart/refreshCart',
      initCart: 'cart/initCart',
      setBetType: 'cart/setBetType',
      setSystemComboDetail: 'cart/setSystemComboDetail',
    }),
  },
  async mounted() {
    this.getBet.system_parts = []
    this.getBet._system_detail.amount_system_to_divide = null
    this.getBet._system_detail.amount_system_equal = null
    this.getBet._system_detail.amount_system = 0.0
    this.getBet._system_detail.fixed_bases = []
    // await this.refreshCart()
    await this.initCart()
  },
}
</script>
